import {CalendarSlot} from "../../entities/CalendarSlot";
import {Van} from "../../../../../server/src/base/entities/leasing/Van";
import {Slot} from "../../../../../server/src/base/entities/leasing/calendar/Slot";
import {CalendarDaySlot} from "../../entities/CalendarDaySlot";

export abstract class IVanCalendar {
    public abstract Update(van:Van);
    public abstract Slots():Array<CalendarSlot>;
    public abstract NextMonth();
    public abstract PreviousMonth();
    public abstract CurrentMonth():Date;
    public abstract FirstDayOfTheMonth():number;
    public abstract LastDayOfTheMonth():number;
    public abstract CalendarSlot(slot:Slot):CalendarDaySlot
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/leasing/IVanCalendar.ts